import { FunctionComponent, memo, SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import { Case } from '~types';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { useGames, useStatusGame } from './hooks';
import { useConfig } from '../hooks';

import GameChange from '~components/game/GameChange';
import { SteamItemImage } from '~components/item';
import Currency from '~components/Currency';
import { Button, Price } from '~ui/index';
import { useKeyPressEvent } from 'react-use';

interface IWinItem {
  getCase: Case;
}

const WinItem: FunctionComponent<IWinItem> = memo(({ getCase }) => {
  const getConfig = useConfig();
  const [statusGame, setStatusGame] = useStatusGame();

  useKeyPressEvent(
    ({ code }) => code === 'KeyS',
    () => {
      const button = document.querySelector(
        '.case-play-win .button[data-event="onSellItem"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useKeyPressEvent(
    ({ code }) => code === 'KeyR',
    () => {
      const button = document.querySelector(
        '.button[data-event="onPlayAgain"]',
      );

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useKeyPressEvent(
    ({ code }) => code === 'KeyI',
    () => {
      const button = document.querySelector('[data-event="goProfile"]');

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  useKeyPressEvent(
    ({ code }) => code === 'KeyC',
    () => {
      const button = document.querySelector('[data-event="goContract"]');

      if (button instanceof HTMLElement) {
        button.click();
      }
    },
  );

  const [getGames] = useGames();
  const { t } = useTranslation();

  const getGame = _.last(getGames)?.getGame;

  const onSetGame = (event: SyntheticEvent) => {
    if (event) {
      event.preventDefault();
    }

    setStatusGame(0);
  };

  if (_.size(getGames) > 1) {
    return null;
  }

  if (!getGame || statusGame !== 4) {
    return null;
  }

  const { getItem } = getGame;

  return (
    <div className="case-play-win">
      <div className="case-item" data-rar={getItem.color}>
        <div className="case-play-win-img">
          <SteamItemImage size="318x157" url={getItem.getImage} />
          <div className="case-play-win-img-name">
            <span>
              {getItem.getName} {getItem?.quality && `- ${getItem?.quality}`}
            </span>
            {getGame?.chance && (
              <div className="drop-chance">{getGame?.chance}%</div>
            )}
          </div>
        </div>

        <div className="case-play-win-btns">
          {getCase?.type !== 3 && (
            <Button
              onClick={onSetGame}
              className="btn-game btn-game--repeat"
              data-event="onPlayAgain"
            >
              <div className="btn-hoykey">r</div>
              <span className="icon material-icons" data-icon="&#xe627;" />
              <span className="text">{t('Play again')}</span>
            </Button>
          )}

          {getGame.status === 1 && (
            <>
              <GameChange
                getGame={getGame}
                type={0}
                className="btn btn-sell"
                onDone={onSetGame}
              >
                <div className="btn-hoykey">s</div>
                {/*//Comment to hide +3% on sell SCRUM-151 */}
                {/* <div className="btn-sale-cost-wrap">
                  <div className="btn-sale-cost">
                    {getConfig.isEU ? (
                      <>
                        <Currency />
                        <Price sum={getGame.price} />
                      </>
                    ) : (
                      <>
                        <Price sum={getGame.price} />
                        <Currency />
                      </>
                    )}
                  </div>

                  <div className="btn-sale-cost percent">+3%</div>
                </div> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                >
                  <path
                    d="M1992,1385.667l16-16h-8V1367h13.333v13.333h-2.667v-8l-16,16Z"
                    transform="translate(-1981.333 -1356.333)"
                    fill="#fff"
                  ></path>
                </svg>
                <span className="text">{t('Sell for')}</span>
                <div className="cost">
                  {getConfig.isEU ? (
                    <>
                      <Currency />
                      <Price sum={getGame.priceSell} />
                    </>
                  ) : (
                    <>
                      <Price sum={getGame.priceSell} />
                      <Currency />
                    </>
                  )}
                </div>
              </GameChange>

              {/* <Link
                className="btn-game btn-game--contracts"
                to="/contract"
                data-event="goContract"
                state={{ gameIds: [getGame.id] }}
              >
                <div className="btn-hoykey">c</div>
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                  >
                    <path
                      d="M17.334,32H14.667V29.334A13.162,13.162,0,0,1,6.4,25.6a13.157,13.157,0,0,1-3.737-8.264H0V14.667H2.667A13.16,13.16,0,0,1,6.4,6.4a13.167,13.167,0,0,1,8.262-3.737V0h2.667V2.666A13.167,13.167,0,0,1,25.6,6.4a13.158,13.158,0,0,1,3.736,8.264H32v2.666H29.333A13.162,13.162,0,0,1,25.6,25.6a13.167,13.167,0,0,1-8.264,3.738V32Zm0-6.666v1.332a10.011,10.011,0,0,0,9.334-9.334H25.334V14.667h1.334a10.013,10.013,0,0,0-9.334-9.333V6.666H14.667V5.333a10.009,10.009,0,0,0-9.332,9.333H6.667v2.666H5.337a10,10,0,0,0,9.329,9.334V25.336ZM16,22.667A6.93,6.93,0,0,1,9.334,16,6.93,6.93,0,0,1,16,9.334,6.93,6.93,0,0,1,22.667,16,6.93,6.93,0,0,1,16,22.667ZM16,12a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"
                      transform="translate(5.333 5.333)"
                      fill="#fff"
                      stroke="rgba(0,0,0,0)"
                      strokeMiterlimit="10"
                      strokeWidth="1"
                    ></path>
                  </svg>
                </div>
                <span className="text">{t('add_to_contract')}</span>
              </Link> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
});

export { WinItem };
